import { Component, computed, input } from '@angular/core';
import { IfFeatureDirective, IfNoFeatureDirective, ModalIdWB } from '@tdwb/core';

import { ModalNotificationDeprecatedComponent } from './deprecated/modal-notification-deprecated.component';
import { ModalNotificationWelcomeComponent } from './content/welcome/modal-notification-welcome.component';
import { ModalNotificationWhatsNewComponent } from './content/whats-new/modal-notification-whats-new.component';

@Component({
  imports: [
    IfNoFeatureDirective,
    IfFeatureDirective,
    ModalNotificationDeprecatedComponent,
    ModalNotificationWelcomeComponent,
    ModalNotificationWhatsNewComponent
  ],
  selector: 'td-wb-modal-notification',
  templateUrl: 'modal-notification.component.html'
})
export class ModalNotificationComponent {
  readonly triggerId = input.required<string>();

  private readonly welcomeModals = new Set<string>([
    'welcome_modal_di',
    'welcome_modal_fp_pia'
  ]);

  protected readonly isWhatsNewModal = computed(() => this.triggerId() === ModalIdWB.WHATS_NEW);

  protected readonly isWelcomeModal = computed(() => this.welcomeModals.has(this.triggerId()));
}
